import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';
import { defaultColors } from '../../../../styles/style-guide';
import { useMailStore } from '../store/mail.store';
import { Avatar } from './Avatar';

const ChatHeader: React.FC = () => {
  const { selectedUser } = useMailStore();
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors.primary || defaultColors.primary;
  return (
    <div className="relative flex items-center gap-4 border-b-[2px] border-[#E1E9EF] bg-white px-6 py-4">
      <div className="relative">
        <Avatar height={48} url={selectedUser?.photo || ''} />
        {/* <div className="absolute bottom-0 right-0 bg-green-500 h-3 w-3 rounded-full" /> */}
      </div>

      <div className="flex flex-col" style={{color: primaryColor}}>
        <h1 className="text-lg font-bold">{selectedUser?.first_name}</h1>
        {/* <span className="text-xs text-[#727272]">Active now</span> */}
      </div>
    </div>
  );
};

export { ChatHeader };
